import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { usePageMeta } from "../lib/usePageMeta";

export function NotFoundPage() {
  const { t } = useTranslation();
  usePageMeta({ title: t("notFound.title"), noindex: true });
  return (
    <div className="flex flex-col items-center gap-4 py-24 text-center">
      <div className="font-sans text-7xl text-amber-400">404</div>
      <h1 className="font-sans text-2xl text-ink-50">{t("notFound.title")}</h1>
      <p className="max-w-sm text-sm text-ink-400">
        {t("notFound.text")}
      </p>
      <Link to="/" className="btn-primary">
        {t("notFound.home")}
      </Link>
    </div>
  );
}
